import React, { useState, useContext, useEffect } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { useHistory } from "react-router-dom";
import LanguageItem from "./LanguageItem";
import { AuthContext } from "../context/AuthContext";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";

const Languages = (props) => {
  const languages = props.languages;
  const onSubmitLanguages = props.onSubmitLanguages;
  const handleRemoveLanguage = props.handleRemoveLanguage;
  const updateLanguage = props.updateLanguage;
  const [language, setLanguage] = useState({ name: "", proficiency: "" });
  const [editing, setEditing] = useState(false);
  const authContext = useContext(AuthContext);
  const [inputError, setInputError] = useState({
    state: false,
    message: "",
  });
  const history = useHistory();

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (e) => {
    setLanguage({ name: e.target.value });
  };
  const onSubmitValidation = (e) => {
    e.preventDefault();
    if (language.name === "") {
      setInputError({ state: true, message: "Please enter a language" });
    } else {
      setInputError({ state: false, message: "" });
      onSubmitLanguages(e, language);
      setLanguage({ name: "", proficiency: "" });
    }
  };
  return (
    <Paper
      elevation={3}
      style={{
        marginTop: "20px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: !props.onMobile ? "48.5%" : "100%",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid #e1e1e1",
          }}
        >
          <h4>{getProfileLabel(props.profileLanguage, "languages")}</h4>
          {!editing && (
            <IconButton
              onClick={() => setEditing(true)}
              variant="outlined"
              color="primary"
            >
              <EditIcon />
            </IconButton>
          )}
          {editing && (
            <IconButton
              onClick={() => {
                setInputError({ state: false, message: "" });
                setEditing(false);
              }}
              variant="outlined"
              color="primary"
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        {languages === undefined || languages.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {getProfileLabel(props.profileLanguage, "noLanguages")}
          </p>
        ) : (
          languages.map((language) => {
            return (
              <LanguageItem
                key={language._id}
                language={language}
                profileLanguage={props.profileLanguage}
                updateLanguage={(e, language) => updateLanguage(e, language)}
                removeLanguage={() => handleRemoveLanguage(language)}
                editing={editing}
              />
            );
          })
        )}
      </div>
      {editing && (
        <form
          onSubmit={(e) => {
            onSubmitValidation(e);
          }}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <TextField
            error={inputError.state}
            type="text"
            name="language"
            label="Enter a language"
            value={language.name}
            onChange={onChange}
            className="form-cotrol"
            style={{ margin: "20px 0px 10px 0px" }}
            helperText={inputError.message}
          />
          <Button type="submit" variant="outlined" color="primary">
            Add language
          </Button>
        </form>
      )}
    </Paper>
  );
};

export default Languages;
